class AnimatedDetails {

  /**
   * Adds animated toggle functionality to given details element.
   *
   * @param {HTMLDetailsElement} el Element to animate.
   * @param {Object} options Animation configuration.
   */
  constructor(el, options = {}) {
    this.options = {
      animationDuration: 300,
      animationEasing: 'ease-out',
      ...options
    };
    this._animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.details = el;
    this.summary = el.querySelector('summary');
    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this.details.open || this.isClosing) {
        this.toggle(true);
      }
      else if (this.details.open || this.isExpanding) {
        this.toggle(false);
      }
    });
  }

  /**
   * Toggle details open state.
   *
   * @param {Boolean} open True if details is opened, false otherwise.
   */
  toggle(open) {
    const summary = this.summary;
    const details = this.details;

    const detailsHeight = details.offsetHeight;
    let startHeight = 0;
    let endHeight = 0;

    if (this._animation) {
      this._animation.cancel();
    }

    // Close
    if (!open) {
      this.isClosing = true;
      this.isExpanding = false;
      startHeight = `${this._animation ? detailsHeight : details.offsetHeight}px`;
      endHeight = `${summary.offsetHeight}px`;
    }
    // Open
    else {
      this.isClosing = false;
      this.isExpanding = true;
      startHeight = `${this._animation ? detailsHeight : summary.offsetHeight}px`;
      details.open = true;
      endHeight = `${details.offsetHeight}px`;
    }

    details.style.overflow = 'hidden';
    this._animation = details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.options.animationDuration,
      easing: this.options.animationEasing
    });
    this._animation.onfinish = () => {
      details.open = open;
      this.isClosing = false;
      this.isExpanding = false;
      this._animation = null;
      details.style.overflow = '';
    };
  }
}

export default AnimatedDetails;
